// Synthetic-subtype aliases. Some Sorcery card text targets card
// alignments that aren't printed as a single subtype on the card.
// "Evil" is the canonical example: a creature is considered Evil if
// its subtype list includes Demon, Monster, or Undead.
//
// Card text that mentions "Evil minions" / "Evil allies" / etc.
// resolves through these aliases at filter-evaluation time. The
// catalog doesn't carry an "Evil" subtype on any minion; the
// expansion lives here so adding a new alignment (Holy?) is one map
// entry.
//
// Pure. No runtime state, no card lookups.

/**
 * Each key is a synthetic subtype that, when listed in a filter,
 * matches a card whose printed subtype list contains ANY of the
 * mapped concrete subtypes (case-insensitive).
 */
export const SUBTYPE_ALIASES = Object.freeze({
  evil: Object.freeze(['demon', 'monster', 'undead']),
});

/**
 * Expand any synthetic subtypes in `wanted` into their concrete
 * member list. Concrete subtypes pass through unchanged. Returns a
 * fresh array (caller can iterate or test directly).
 *
 * @param {string[]} wanted - lowercase subtype tokens
 * @returns {string[]}
 */
export function expandSubtypeAliases(wanted) {
  if (!Array.isArray(wanted) || wanted.length === 0) return [];
  const out = [];
  for (const w of wanted) {
    const alias = SUBTYPE_ALIASES[w];
    if (alias) {
      for (const concrete of alias) out.push(concrete);
    } else {
      out.push(w);
    }
  }
  return out;
}
